/**
 * Author page pager (sections/pb-author-articles.liquid).
 * Every card is in the HTML (crawlable); this only shows one page at a time with numbered buttons.
 * Without JS all cards stay visible.
 */
(() => {
  if (customElements.get('pb-author-pager')) return;

  class PbAuthorPager extends HTMLElement {
    connectedCallback() {
      this.cards = [...this.querySelectorAll('[data-author-card]')];
      this.perPage = Number(this.dataset.perPage) || 12;
      this.pageCount = Math.ceil(this.cards.length / this.perPage);
      this.nav = this.querySelector('[data-author-pager-nav]');
      this.heading = this.querySelector('[data-author-pager-heading]');
      if (!this.nav || this.pageCount < 2) return;

      this.nav.hidden = false;
      this.nav.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-page]');
        if (button) this.show(Number(button.dataset.page), true);
      });
      this.show(1, false);
    }

    show(page, moveFocus) {
      this.page = Math.min(Math.max(page, 1), this.pageCount);
      const start = (this.page - 1) * this.perPage;
      this.cards.forEach((card, index) => {
        card.hidden = index < start || index >= start + this.perPage;
      });
      this.renderNav();

      if (moveFocus) {
        this.scrollIntoView({ block: 'start' });
        this.heading?.focus({ preventScroll: true });
      }
    }

    renderNav() {
      const { labelPrevious = '', labelNext = '', labelPage = '' } = this.dataset;
      const button = (target, text, label, extra = '') =>
        `<button type="button" class="pb-author__page" data-page="${target}" aria-label="${label}" ${extra}>${text}</button>`;

      let html = button(this.page - 1, '&lsaquo;', labelPrevious, this.page === 1 ? 'disabled' : '');
      for (let i = 1; i <= this.pageCount; i += 1) {
        html += button(i, i, labelPage.replace('__PAGE__', i), i === this.page ? 'aria-current="page"' : '');
      }
      html += button(this.page + 1, '&rsaquo;', labelNext, this.page === this.pageCount ? 'disabled' : '');
      this.nav.innerHTML = html;
    }
  }

  customElements.define('pb-author-pager', PbAuthorPager);
})();
